export const VAIR_AUTHORIZE_API_ROUTE = '/v1/vair/authorize';

/** `link` connects VAIR to the logged-in user; `signin` ends in a Firebase sign-in instead. */
export type VairAuthorizeMode = 'link' | 'signin';
export const VAIR_AUTHORIZE_SIGNIN_MODE: VairAuthorizeMode = 'signin';

export interface AuthorizeRequestPayload {
  mode?: VairAuthorizeMode;
  /** Same-origin path to land on afterwards; anything else is dropped server-side. */
  returnTo?: string;
}

export interface AuthorizeResponsePayload {
  /** VAIR's consent screen; the browser navigates here. */
  authorizationUrl: string;
}
